import { IconCases, IconCourier, IconDashboard, IconLock, IconMerchants, IconSearch } from '../icons';

/**
 * Courier portal navigation.
 *
 * `paidOnly` items are the depth the Intelligence plan sells. They stay
 * visible on the pilot rather than being hidden — a plan you cannot see is a
 * plan nobody buys — and open a page that explains what is behind them. The
 * server refuses the data either way (UPGRADE_REQUIRED), so this is signage,
 * not security.
 */
export const courierNavItems = [
  {
    to: '/courier/dashboard',
    label: 'Dashboard',
    icon: IconDashboard,
    title: 'Dashboard',
    description: 'Reported issues across your network, at a glance.'
  },
  {
    to: '/courier/cases',
    label: 'Reports',
    icon: IconCases,
    paidOnly: true,
    title: 'Reports',
    description: 'Every delivery issue customers have raised against your network.'
  },
  {
    to: '/courier/merchants',
    label: 'Retailers',
    icon: IconMerchants,
    paidOnly: true,
    title: 'Retailers',
    description: 'Which retailers your reported issues cluster around.'
  },
  {
    to: '/courier/hotspots',
    label: 'Hotspots',
    icon: IconSearch,
    paidOnly: true,
    title: 'Postcode hotspots',
    description: 'The outward codes generating the most reports.'
  },
  {
    to: '/courier/account',
    label: 'Account',
    icon: IconLock,
    title: 'Account',
    description: 'Your plan, billing and account details.'
  }
];

export const courierNavIcon = IconCourier;

const fallbackMeta = { title: 'ParcelBuddy', description: 'Courier portal.' };

export const getCourierPageMeta = (pathname) =>
  courierNavItems.find((item) => pathname === item.to || pathname.startsWith(`${item.to}/`)) ||
  fallbackMeta;
